// ============ i18n Translation Dictionary ============

export type Lang = 'zh' | 'en'

export const translations = {
  // ---- Nav ----
  'nav.home': { zh: '首页', en: 'Home' },
  'nav.competency': { zh: '能力模型', en: 'Competency' },
  'nav.tasks': { zh: '任务构建', en: 'Tasks' },
  'nav.tools': { zh: '工具注册', en: 'Tools' },
  'nav.rubric': { zh: '评分标准', en: 'Rubric' },
  'nav.run': { zh: 'Agent运行', en: 'Run' },
  'nav.traces': { zh: '轨迹查看', en: 'Traces' },
  'nav.reports': { zh: '评测报告', en: 'Reports' },
  'nav.leaderboard': { zh: '排行榜', en: 'Leaderboard' },
  'nav.contribute': { zh: '贡献任务', en: 'Contribute' },
  'nav.expert': { zh: '专家工作台', en: 'Expert' },
  'nav.pipeline': { zh: '数据闭环', en: 'Pipeline' },
  'nav.governance': { zh: '数据治理', en: 'Governance' },
  'nav.batch': { zh: '批量评测', en: 'Batch' },
  'nav.settings': { zh: '设置', en: 'Settings' },

  // ---- Common ----
  'common.loading': { zh: '加载中...', en: 'Loading...' },
  'common.error': { zh: '加载失败', en: 'Failed to Load' },
  'common.retry': { zh: '重试', en: 'Retry' },
  'common.search': { zh: '搜索', en: 'Search' },
  'common.cancel': { zh: '取消', en: 'Cancel' },
  'common.save': { zh: '保存', en: 'Save' },
  'common.create': { zh: '创建', en: 'Create' },
  'common.delete': { zh: '删除', en: 'Delete' },
  'common.edit': { zh: '编辑', en: 'Edit' },
  'common.new': { zh: '新建', en: 'New' },
  'common.all': { zh: '全部', en: 'All' },
  'common.status': { zh: '状态', en: 'Status' },
  'common.actions': { zh: '操作', en: 'Actions' },

  // ---- Home ----
  'home.title': { zh: 'DecisionCraft', en: 'DecisionCraft' },
  'home.subtitle': { zh: '职业决策能力评估引擎', en: 'Competency Assessment Engine for Professional Decision-Making' },
  'home.stat.competencies': { zh: '能力模型数', en: 'Total Competencies' },
  'home.stat.tasks': { zh: '任务总数', en: 'Total Tasks' },
  'home.stat.tools': { zh: '可用工具', en: 'Active Tools' },
  'home.stat.sessions': { zh: '运行次数', en: 'Sessions Run' },
  'home.quickLinks': { zh: '快速入口', en: 'Quick Links' },
  'home.recentActivity': { zh: '最近活动', en: 'Recent Activity' },
  'home.noTraces': { zh: '暂无轨迹记录，运行Agent即可开始。', en: 'No traces recorded yet. Run an agent to get started.' },
  'home.heroDesc': { zh: '衡量AI Agent在真实职业场景中的决策能力。覆盖旅游、商业、财务等多个领域，基于专家定义的评分标准，提供可验证的能力评估。', en: 'Measuring AI agent decision-making in real professional scenarios. Covering tourism, business, finance and more, with expert-defined rubrics and verifiable assessments.' },
  'home.contribute': { zh: '贡献任务', en: 'Contribute a Task' },
  'home.viewLeaderboard': { zh: '查看排行榜', en: 'View Leaderboard' },
  'home.domains': { zh: '领域覆盖', en: 'Domain Coverage' },
  'home.differentiators': { zh: '核心优势', en: 'Why DecisionCraft' },
  'home.diff.broad': { zh: '最广覆盖', en: 'Broadest Coverage' },
  'home.diff.broadDesc': { zh: '覆盖多个职业领域，持续扩展中', en: 'Covering multiple professional domains, continuously expanding' },
  'home.diff.verifiable': { zh: '可验证结果', en: 'Verifiable Outcomes' },
  'home.diff.verifiableDesc': { zh: '所有任务输出可被客观验证', en: 'All task outputs are objectively verifiable' },
  'home.diff.long': { zh: '长周期任务', en: 'Long-Horizon' },
  'home.diff.longDesc': { zh: '模拟真实工作流程，非简化对话', en: 'Simulating real workflows, not simplified chats' },
  'home.diff.economic': { zh: '经济价值', en: 'Economically Valuable' },
  'home.diff.economicDesc': { zh: '任务来源于真实职业场景', en: 'Tasks drawn from real professional scenarios' },

  // ---- Competency Studio ----
  'comp.title': { zh: '能力模型工作室', en: 'Competency Studio' },
  'comp.subtitle': { zh: '定义和管理能力模型、维度及评分标准', en: 'Define and manage competency models with dimensions and rubrics' },
  'comp.new': { zh: '新建能力模型', en: 'New Competency' },
  'comp.search': { zh: '按名称、中文名或领域搜索...', en: 'Search competencies by name, Chinese name, or domain...' },
  'comp.nameEn': { zh: '名称（英文）', en: 'Name (English)' },
  'comp.nameCn': { zh: '名称（中文）', en: 'Name (Chinese)' },
  'comp.domain': { zh: '领域', en: 'Domain' },
  'comp.description': { zh: '描述', en: 'Description' },
  'comp.dimensions': { zh: '评估维度', en: 'Dimensions' },
  'comp.tasks': { zh: '任务', en: 'Tasks' },
  'comp.rubrics': { zh: '评分标准', en: 'Rubrics' },
  'comp.cases': { zh: '案例', en: 'Cases' },
  'comp.addDim': { zh: '添加维度', en: 'Add' },
  'comp.weight': { zh: '权重', en: 'Weight' },

  // ---- Task Builder ----
  'task.title': { zh: '任务构建器', en: 'Task Builder' },
  'task.subtitle': { zh: '设计和管理关联能力模型的评测任务', en: 'Design and manage assessment tasks tied to competency models' },
  'task.new': { zh: '新建任务', en: 'New Task' },
  'task.search': { zh: '搜索任务标题、描述或难度...', en: 'Search tasks by title, description, or difficulty...' },
  'task.filterComp': { zh: '所有能力模型', en: 'All Competencies' },
  'task.taskTitle': { zh: '任务标题', en: 'Title' },
  'task.difficulty': { zh: '难度', en: 'Difficulty' },
  'task.expectedSteps': { zh: '预期步骤数', en: 'Expected Steps' },
  'task.toolsAllowed': { zh: '允许工具', en: 'Tools Allowed' },
  'task.competency': { zh: '能力模型', en: 'Competency' },
  'task.rubricId': { zh: '评分标准ID', en: 'Rubric ID' },

  // ---- Tool Registry ----
  'tool.title': { zh: '工具注册中心', en: 'Tool Registry' },
  'tool.subtitle': { zh: '管理和监控Agent可用工具', en: 'Manage and monitor available agent tools' },
  'tool.registered': { zh: '个工具已注册', en: 'tools registered' },
  'tool.searchPlaceholder': { zh: '搜索工具...', en: 'Search tools...' },
  'tool.sandbox': { zh: '沙箱', en: 'Sandbox' },
  'tool.noSandbox': { zh: '无沙箱', en: 'No Sandbox' },
  'tool.active': { zh: '已启用', en: 'Active' },
  'tool.inactive': { zh: '已禁用', en: 'Inactive' },
  'tool.details': { zh: '工具详情', en: 'Tool Details' },
  'tool.functionSchema': { zh: '函数Schema', en: 'Function Schema' },
  'tool.usageExample': { zh: '使用示例', en: 'Usage Example' },
  'tool.usageGuide': { zh: '使用指南', en: 'Usage Guide' },
  'tool.viewDetails': { zh: '查看详情', en: 'View Details' },
  'tool.close': { zh: '关闭', en: 'Close' },
  'tool.agentCall': { zh: 'Agent调用方式', en: 'Agent Call Format' },
  'tool.expectedResponse': { zh: '预期响应', en: 'Expected Response' },

  // ---- Rubric Designer ----
  'rubric.title': { zh: '评分标准设计器', en: 'Rubric Designer' },
  'rubric.subtitle': { zh: '设计和管理机器可执行的评分规则', en: 'Design and manage machine-executable rubric rules' },
  'rubric.new': { zh: '新建评分标准', en: 'New Rubric' },
  'rubric.criteria': { zh: '评分标准', en: 'Criteria' },
  'rubric.detectionRules': { zh: '检测规则', en: 'Detection Rules' },
  'rubric.level': { zh: '等级', en: 'Level' },
  'rubric.score': { zh: '分数', en: 'Score' },

  // ---- Agent Runner ----
  'run.title': { zh: 'Agent运行器', en: 'Agent Runner' },
  'run.subtitle': { zh: '配置并执行Agent任务', en: 'Configure and execute agent tasks' },
  'run.config': { zh: '配置', en: 'Configuration' },
  'run.execution': { zh: '执行', en: 'Execution' },
  'run.task': { zh: '任务', en: 'Task' },
  'run.agentName': { zh: 'Agent名称', en: 'Agent Name' },
  'run.model': { zh: '模型', en: 'Model' },
  'run.maxSteps': { zh: '最大步骤', en: 'Max Steps' },
  'run.timeout': { zh: '超时（秒）', en: 'Timeout (seconds)' },
  'run.runAgent': { zh: '运行Agent', en: 'Run Agent' },
  'run.stop': { zh: '停止', en: 'Stop' },
  'run.running': { zh: '运行中...', en: 'Running...' },
  'run.complete': { zh: '完成', en: 'Complete' },
  'run.steps': { zh: '步骤', en: 'Steps' },
  'run.score': { zh: '得分', en: 'Score' },
  'run.result': { zh: '结果', en: 'Result' },
  'run.pass': { zh: '通过', en: 'Pass' },
  'run.fail': { zh: '未通过', en: 'Fail' },
  'run.summary': { zh: '运行摘要', en: 'Run Summary' },
  'run.placeholder': { zh: '配置并运行Agent后，执行步骤将显示在此处', en: 'Configure and run an agent to see execution steps here' },

  // ---- Trace Viewer ----
  'trace.title': { zh: '轨迹查看器', en: 'Trace Viewer' },
  'trace.subtitle': { zh: '检查Agent执行轨迹和决策过程', en: 'Inspect agent execution traces and decision processes' },
  'trace.search': { zh: '按轨迹ID、Agent名称或任务ID搜索...', en: 'Search by trace ID, agent name, or task ID...' },
  'trace.timeline': { zh: '执行时间线', en: 'Execution Timeline' },
  'trace.viewReport': { zh: '查看报告', en: 'View Report' },
  'trace.noSteps': { zh: '暂无步骤记录', en: 'No steps recorded yet' },
  'trace.noTraces': { zh: '暂无轨迹', en: 'No traces found' },
  'trace.runToGenerate': { zh: '运行Agent即可生成轨迹', en: 'Run an agent to generate traces' },

  // ---- Report ----
  'report.title': { zh: '评测报告', en: 'Reports' },
  'report.subtitle': { zh: '能力评估报告与分析', en: 'Competency assessment reports and analysis' },
  'report.totalScore': { zh: '总分', en: 'Total Score' },
  'report.breakdown': { zh: '分数明细', en: 'Score Breakdown' },
  'report.strengths': { zh: '优势', en: 'Strengths' },
  'report.weaknesses': { zh: '待改进', en: 'Weaknesses' },
  'report.summary': { zh: '总结', en: 'Summary' },
  'report.noReports': { zh: '暂无报告', en: 'No reports generated' },
  'report.runToGenerate': { zh: '运行Agent即可生成报告', en: 'Run an agent to generate reports' },
  'report.viewTrace': { zh: '查看轨迹', en: 'View Trace' },
  'report.competencyReport': { zh: '能力评估报告', en: 'Competency Report' },

  // ---- Leaderboard ----
  'lb.title': { zh: '排行榜', en: 'Leaderboard' },
  'lb.subtitle': { zh: 'Agent能力评测全球排名', en: 'Global Agent Competency Rankings' },
  'lb.rank': { zh: '排名', en: 'Rank' },
  'lb.agent': { zh: 'Agent', en: 'Agent' },
  'lb.model': { zh: '模型', en: 'Model' },
  'lb.score': { zh: '总分', en: 'Score' },
  'lb.sessions': { zh: '评测次数', en: 'Sessions' },
  'lb.avgScore': { zh: '平均分', en: 'Avg Score' },
  'lb.passRate': { zh: '通过率', en: 'Pass Rate' },
  'lb.lastRun': { zh: '最近评测', en: 'Last Run' },
  'lb.noData': { zh: '暂无排行数据，运行Agent评测后自动生成。', en: 'No ranking data yet. Run agent evaluations to populate.' },
  'lb.confidence': { zh: '置信度', en: 'Confidence' },
  'lb.verifiedOnly': { zh: '仅显示通过反作弊审核的提交', en: 'Showing only anti-cheat verified submissions' },
  'lb.submissions': { zh: '提交总数', en: 'Submissions' },

  // ---- Footer ----
  'footer.tagline': { zh: 'DecisionCraft — 职业决策能力评估引擎', en: 'DecisionCraft — Competency Assessment Engine for Professional Decision-Making' },
  'footer.copyright': { zh: '© 2026 DecisionCraft 平台. 保留所有权利.', en: '© 2026 DecisionCraft Platform. All rights reserved.' },

  // ---- Contribute Task ----
  'contribute.title': { zh: '贡献任务', en: 'Contribute a Task' },
  'contribute.subtitle': { zh: '提交您的专业任务，经审核后发布至平台', en: 'Submit your professional task for review and publication' },
  'contribute.guidelines': { zh: '提交指南', en: 'Submission Guidelines' },
  'contribute.guideline1': { zh: '任务应基于真实职业场景', en: 'Tasks should be based on real professional scenarios' },
  'contribute.guideline2': { zh: '任务描述需清晰完整，包含所有必要约束条件', en: 'Task descriptions must be clear and complete with all necessary constraints' },
  'contribute.guideline3': { zh: '难度等级参考：L1-L2简单，L3-L4中等，L5-L6困难，L7-L8极难', en: 'Difficulty: L1-L2 Easy, L3-L4 Medium, L5-L6 Hard, L7-L8 Expert' },
  'contribute.guideline4': { zh: '提交后任务状态为"审核中"，专家审核通过后发布', en: 'Submitted tasks will be "Under Review", published after expert approval' },
  'contribute.taskTitle': { zh: '任务标题', en: 'Task Title' },
  'contribute.competency': { zh: '所属能力模型', en: 'Competency' },
  'contribute.difficulty': { zh: '难度等级', en: 'Difficulty' },
  'contribute.tools': { zh: '允许工具', en: 'Allowed Tools' },
  'contribute.expectedSteps': { zh: '预期步骤数', en: 'Expected Steps' },
  'contribute.description': { zh: '任务描述', en: 'Task Description' },
  'contribute.descriptionPlaceholder': { zh: '请详细描述任务场景、用户画像、约束条件、必含要求等...', en: 'Describe the task scenario, user profile, constraints, requirements...' },
  'contribute.contributor': { zh: '提交者信息', en: 'Contributor Info' },
  'contribute.name': { zh: '姓名', en: 'Name' },
  'contribute.role': { zh: '角色', en: 'Role' },
  'contribute.organization': { zh: '机构', en: 'Organization' },
  'contribute.submit': { zh: '提交任务', en: 'Submit Task' },
  'contribute.submitting': { zh: '提交中...', en: 'Submitting...' },
  'contribute.success': { zh: '任务提交成功！任务ID:', en: 'Task submitted successfully! Task ID:' },
  'contribute.error': { zh: '提交失败，请重试', en: 'Submission failed, please try again' },
  'contribute.selectCompetency': { zh: '请选择能力模型', en: 'Select a competency' },
  'contribute.selectDifficulty': { zh: '请选择难度', en: 'Select difficulty' },
  'contribute.recentSubmissions': { zh: '最近提交', en: 'Recent Submissions' },
  'contribute.noSubmissions': { zh: '暂无提交记录', en: 'No submissions yet' },

  // ---- Contribute Task: New Sections ----
  'contribute.benefits': { zh: '贡献者权益', en: 'What You Get' },
  'contribute.benefit1': { zh: '洞察Agent在您专业领域的表现', en: 'Insight into agent performance in your domain' },
  'contribute.benefit2': { zh: '高质量贡献者获得论文共同署名权', en: 'Co-authorship on manuscript for high-impact contributions' },
  'contribute.benefit3': { zh: '优秀任务可获得奖金激励', en: 'Monetary awards for high-impact contributions' },
  'contribute.criteria': { zh: '任务核心标准', en: 'Task Criteria' },
  'contribute.complex': { zh: '复杂性', en: 'Complex' },
  'contribute.complexDesc': { zh: '任务需要专家数天完成，而非几分钟', en: 'Takes experts days, not minutes' },
  'contribute.representative': { zh: '代表性', en: 'Representative' },
  'contribute.representativeDesc': { zh: '使用真实职业场景中的工具和工作流', en: 'Use real industry tools and workflows' },
  'contribute.verifiable': { zh: '可验证性', en: 'Verifiable' },
  'contribute.verifiableDesc': { zh: '输出可被确定性验证或按明确标准评分', en: 'Outputs are deterministic or scored against clear rubric' },
  'contribute.badExample': { zh: '反面示例', en: 'Bad Example' },
  'contribute.goodExample': { zh: '正面示例', en: 'Good Example' },
  'contribute.structure': { zh: '提交结构', en: 'Submission Structure' },
  'contribute.step1': { zh: '任务描述', en: 'Task Description' },
  'contribute.step1Desc': { zh: 'Agent需要完成什么', en: 'What the agent must accomplish' },
  'contribute.step2': { zh: '输入', en: 'Input' },
  'contribute.step2Desc': { zh: '提供的文件、数据和上下文', en: 'Files, data, and context provided' },
  'contribute.step3': { zh: '工具', en: 'Software' },
  'contribute.step3Desc': { zh: '需要使用的专业工具', en: 'Professional tools required' },
  'contribute.step4': { zh: '输出', en: 'Output' },
  'contribute.step4Desc': { zh: '预期交付物', en: 'Expected deliverables' },
  'contribute.step5': { zh: '评估', en: 'Evaluation' },
  'contribute.step5Desc': { zh: '如何衡量成功', en: 'How success is measured' },
  'contribute.demoTasks': { zh: '演示任务', en: 'Demo Tasks' },
  'contribute.viewDetails': { zh: '查看详情', en: 'View Details' },
} as const

export type TranslationKey = keyof typeof translations

export function t(key: TranslationKey, lang: Lang): string {
  const entry = translations[key]
  if (!entry) return key
  return entry[lang]
}
